"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var interfaces_1 = require("@hudled/interfaces");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var Modal_1 = __importDefault(require("atomicComponents/organisms/Modal"));
var ModalContent_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalContent"));
var ModalFooter_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalFooter"));
var ModalHeader_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalHeader"));
var FieldCheckbox_1 = __importDefault(require("components/Form/FieldCheckbox"));
var FieldText_1 = __importDefault(require("components/Form/FieldText"));
var InviteUserDropdown_1 = __importDefault(require("containers/InviteUserModal/InviteUserDropdown"));
var TeamDropdown_1 = __importDefault(require("containers/InviteUserModal/TeamDropdown"));
var Button_1 = __importDefault(require("shared/components/Button"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var validators_1 = require("utils/form/validators");
var single_1 = require("utils/selectors/single");
var InviteModal = function (_a) {
    var _b, _c;
    var open = _a.open, onClose = _a.onClose, onPreSubmit = _a.onPreSubmit, onPostSubmit = _a.onPostSubmit, company = _a.company, type = _a.type, targetDocRef = _a.targetDocRef, targetField = _a.targetField, defaultName = _a.defaultName, createUser = _a.createUser;
    var firebase = (0, react_redux_firebase_1.useFirebase)();
    var authState = (0, react_redux_1.useSelector)(single_1.selectAuth);
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var onSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var invitationRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!onPreSubmit) return [3 /*break*/, 2];
                    return [4 /*yield*/, onPreSubmit(__assign({}, values))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [4 /*yield*/, firebase.firestore().collection('invitations').add(__assign(__assign({}, values), { targetDocRef: targetDocRef, targetField: targetField, inviterId: authState.uid, companyId: company.id, createUser: createUser, type: type || (profile.isAdmin ? 'fromAdmin' : 'fromCoworker') }))];
                case 3:
                    invitationRef = _a.sent();
                    if (!onPostSubmit) return [3 /*break*/, 5];
                    return [4 /*yield*/, onPostSubmit(__assign(__assign({}, values), { invitationRef: invitationRef }))];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    onClose();
                    return [2 /*return*/];
            }
        });
    }); };
    var initialValues = {
        accessLevel: (0, end2end_1.userCan)(interfaces_1.ACCESS_LEVEL.Admin) ? interfaces_1.ACCESS_LEVEL.Admin : interfaces_1.ACCESS_LEVEL.User,
    };
    if (defaultName) {
        var _d = __read(defaultName.split(' '), 2), firstName = _d[0], lastName = _d[1];
        initialValues.firstName = firstName;
        initialValues.lastName = lastName;
    }
    if (profile.isAdmin) {
        initialValues.blockSend = true;
        if (!((_b = company.adminIds) === null || _b === void 0 ? void 0 : _b.length) && !((_c = company.adminInvitationIds) === null || _c === void 0 ? void 0 : _c.length)) {
            initialValues.accessLevel = interfaces_1.ACCESS_LEVEL.Owner;
        }
    }
    return ((0, jsx_runtime_1.jsx)(Modal_1.default, __assign({ open: open, onClose: onClose, label: "Invite user modal", sx: { minWidth: 500 } }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: onSubmit, subscription: { submitting: true }, initialValues: initialValues, validate: (0, validators_1.requiredFields)(['firstName', 'lastName', 'email']) }, { children: function (_a) {
                var handleSubmit = _a.handleSubmit, submitting = _a.submitting;
                return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(ModalHeader_1.default, { children: (0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ level: 3 }, { children: ["Invite users to ", company.name] })) }), (0, jsx_runtime_1.jsxs)(ModalContent_1.default, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(FieldText_1.default, { label: "First Name", name: "firstName", sx: { mr: 1 }, color: "info" }), (0, jsx_runtime_1.jsx)(FieldText_1.default, { label: "Last Name", name: "lastName", color: "info" })] })), (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center", mt: 4 }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ flexGrow: 1 }, { children: (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "email", color: "info", placeholder: "Enter email", title: "Enter email" }) })), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "accessLevel", disabled: submitting, component: InviteUserDropdown_1.default })] })), profile.isAdmin && ((0, jsx_runtime_1.jsx)(Box_1.default, __assign({ ml: -2, mt: 2 }, { children: (0, jsx_runtime_1.jsx)(FieldCheckbox_1.default, { name: "blockSend", label: "Don't send (Super-Admin)" }) })))] }), (0, jsx_runtime_1.jsx)(ModalFooter_1.default, { children: (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }, { children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "companyTeamId", disabled: submitting, component: TeamDropdown_1.default }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ type: "submit", color: "secondary", disabled: submitting }, { children: "Submit" }))] })) })] })));
            } })) })));
};
exports.default = InviteModal;
